import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Form, Image, Row } from 'react-bootstrap';
import camera from '../../Assets/Img/camera.png';
import '../Profile/profile.scss';
import { CircleUserRound } from 'lucide-react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import config from '../../Api/config';
import { formatDate } from '../../helper';
import Swal from 'sweetalert2';
import SignatureImage from './signatureImage';
import DoctorIdImage from './doctorIdImage';
import RppsUpload from './rppsUpload';

const DoctorProfile = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const [profileData, setProfileData] = useState({
        ...state?.userData,
        dateOfBirth: formatDate(state?.userData?.dateOfBirth),
    });

    useEffect(() => {
        console.log('profileData', profileData);
    }, [profileData]);

    const showSuccessPopup = (title) => {
        Swal.fire({
            title: t('uploadSuccess'),
            text: `${title} ${t('uploadedSuccessfully')}`,
            icon: 'success',
            confirmButtonText: 'OK',
            timer: 3000,
            timerProgressBar: true,
        });
    };

    const handleImageUpdate = (field, value) => {
        setProfileData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <Container fluid>
            <div className="profile_header">
                <Card className="mb-4">
                    <Card.Body className="modal_form">
                        <h5 className="fw-semibold mb-4">
                            {t('nameAndPicTitle')}
                        </h5>
                        <div className="profile_image mb-4 custom_disabled">
                            {profileData?.profileImagePath ? (
                                <Image
                                    src={`${config.img_URL}/${profileData.profileImagePath}`}
                                />
                            ) : (
                                <CircleUserRound width={120} height={120} />
                            )}
                            <div role="button" className="image_upload_button">
                                <Form.Control type="file" />
                                <img
                                    src={camera}
                                    alt="camera"
                                    style={{ height: '24px', width: '24px' }}
                                />
                            </div>
                        </div>
                        <Row className="mt-3 mb-3">
                            <Col md={4} className="mb-3">
                                <SignatureImage
                                    email={profileData?.email}
                                    image={profileData?.signatureImagePath}
                                    onSuccess={(newPath) => {
                                        handleImageUpdate(
                                            'signatureImagePath',
                                            newPath
                                        );
                                        showSuccessPopup(t('signatureImage'));
                                    }}
                                />
                            </Col>
                            <Col md={4} className="mb-3">
                                <RppsUpload
                                    email={profileData?.email}
                                    image={profileData?.rpcsIdImagePath}
                                    onSuccess={(newPath) => {
                                        handleImageUpdate(
                                            'rpcsIdImagePath',
                                            newPath
                                        );
                                        showSuccessPopup(t('rppsImage'));
                                    }}
                                />
                            </Col>
                            <Col md={4} className="mb-3">
                                <DoctorIdImage
                                    email={profileData?.email}
                                    image={profileData?.doctorIdImagePath}
                                    onSuccess={(newPath) => {
                                        handleImageUpdate(
                                            'doctorIdImagePath',
                                            newPath
                                        );
                                        showSuccessPopup(t('doctorIdImage'));
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row className="custom_disabled">
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('firstName')}</Form.Label>
                                    <Form.Control
                                        value={profileData?.name || ''}
                                        type="text"
                                        name="name"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('name')}</Form.Label>
                                    <Form.Control
                                        value={profileData?.lastName || ''}
                                        type="text"
                                        name="lastName"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('email')}</Form.Label>
                                    <Form.Control
                                        value={profileData?.email || ''}
                                        type="email"
                                        name="email"
                                        required
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('RPPS')}</Form.Label>
                                    <Form.Control
                                        value={
                                            profileData?.doctorRppsNumber || ''
                                        }
                                        type="text"
                                        name="doctorRppsNumber"
                                        required
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('ID du médecin')}
                                    </Form.Label>
                                    <Form.Control
                                        value={
                                            profileData?.doctorIdOfRegistration ||
                                            ''
                                        }
                                        type="text"
                                        name="doctorIdOfRegistration"
                                        required
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>
            <div className="profile_details custom_disabled">
                <Card className="mb-4">
                    <Card.Body className="modal_form">
                        <h5 className="fw-semibold mb-4">
                            {t('personalInformation')}
                        </h5>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('userType')}</Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="userType"
                                        required
                                        readOnly
                                    >
                                        <option value="">
                                            {profileData?.userType || ''}
                                        </option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('dateofBirth')}</Form.Label>
                                    <Form.Control
                                        value={profileData?.dateOfBirth || ''}
                                        type="text"
                                        name="dateOfBirth"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('phone')}</Form.Label>
                                    <Form.Control
                                        value={profileData?.mobile || ''}
                                        type="text"
                                        name="mobile"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t(
                                            'Médecin Adresse du Centre de Santé'
                                        )}
                                    </Form.Label>
                                    <Form.Control
                                        value={
                                            profileData?.doctorAddressOfTheHealthCenter ||
                                            ''
                                        }
                                        type="text"
                                        name="doctorAddressOfTheHealthCenter"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('Ville')}</Form.Label>
                                    <Form.Control
                                        value={profileData?.city || ''}
                                        type="text"
                                        name="city"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('Designation')}</Form.Label>
                                    <Form.Control
                                        value={profileData?.drDesignation || ''}
                                        type="text"
                                        name="drDesignation"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {t('Images retino obligatoires')}
                                    </Form.Label>
                                    <Form.Control
                                        value={
                                            (profileData?.imageRetino
                                                ? 'Yes'
                                                : 'No') || ''
                                        }
                                        type="text"
                                        name="imageRetino"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('expressTest')}</Form.Label>
                                    <Form.Control 
                                        
                                        value={
                                            (profileData?.isDoctorExpressAvailable
                                                ? 'Yes'
                                                : 'No') || ''
                                        }
                                        type="text"
                                        name="isDoctorExpressAvailable"
                                        readOnly
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    );
};

export default DoctorProfile;
